import styled from "@emotion/styled";

const StyledHeroWithLogos = styled.header`
  margin-top: calc(var(--header-height) + 50px);
  text-align: center;
  position: relative;

  .text {
    max-width: 800px;
    margin: var(--x-large) auto;
  }

  .h1 {
    margin-bottom: var(--mini);
  }
`;

interface HeroWithLogosProps {
  title: string;
  text: string;
}

export const HeroWithLogos = ({ title, text }: HeroWithLogosProps) => (
  <StyledHeroWithLogos className="pattern-bg">
    <div className="row">
      <div className="text">
        <h1 className="h1">{title}</h1>
        <p>{text}</p>
      </div>
    </div>
  </StyledHeroWithLogos>
);
